import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getConfirmFlow = asyncThunkWrapper({ 
  model: 'confirmFlows', 
  action: 'getConfirmFlow', 
  func: async () => {
    const params = { attributes: ['id', 'updated_at'] };
    const response = await axios.get(`/confirm_flow`, { params });

    return response.data;
  } 
});
export const createConfirmFlow = asyncThunkWrapper({ 
  model: 'confirmFlows', 
  action: 'createConfirmFlow', 
  func: async () => {
    const attributes = ['id', 'updated_at'];
    const response = await axios.post(`/confirm_flow`, { attributes });

    return response.data;
  } 
});
export const deleteConfirmFlow = asyncThunkWrapper({ 
  model: 'confirmFlows', 
  action: 'deleteConfirmFlow', 
  func: async () => {
    const response = await axios.delete(`/confirm_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveConfirmFlow = createAction('confirmFlows/clearLocalActiveConfirmFlow');